<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  @if (isUserAuthorized) {
    <div class="opm-cm-container">
      <table class="cm-grid">

        <tbody>
          <tr>
            <td class="field">GEO</td>
            <td class="field">MemberFirm Code</td>
            <td class="field"></td>
          </tr>
          <tr>
            @if (isLoadedgeo) {
              <td class="value">
                <div class="geodropdown">
                  <ng-select class="geo-mf-ng-select"
                             [items]="geocode"
                             bindLabel="name"
                             placeholder="Select GEO"
                             appendTo="body"
                             multiple="true"
                             (change)="loadMF($event)"
                             [maxSelectedItems]="1"
                             [(ngModel)]="selectedgeo">
                  </ng-select>
                </div>
              </td>
            }

            <td class="value" [ngClass]="isLoadedmf ? 'notSelected' : 'Selected'">
              <ng-select #ngselectmf class="mf-ng-select"
                         [items]="mfcodeobs | async"
                         bindLabel="name"
                         placeholder="Select Memberfirm Code"
                         appendTo="body"
                         multiple="true"
                         [maxSelectedItems]="3"
                         [(ngModel)]="selectedmf">
              </ng-select>
            </td>
            <td class="value" style="width:70px">
              <button (click)="getValues()"
                      [disabled]="!isFormValid()">
                Submit
              </button>
            </td>
            <td class="value" style="width:70px">
              <button (click)="viewBaseMappings()">
                View All Base Mappings
              </button>
            </td>
            <td class="value" style="width:70px">
              <button (click)="downloadExcel()">
                Export All Mappings
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    @if (!!gridDataModel && !visiblNoMatchesFoundPopup) {
      <div class="search-results-container">
        @if (isPagingVisible) {
          <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                      (pageChanged)="onPageChange($event)">
          </opm-paging>
        }

        @switch (gridResult) {
          @case (gridResultEnum.Basemapping) {
            <opm-grid [metaName]="gridTypeEnum.Basemapping" [users]="gridDataModel.BaseMappingDetails" [baseMapping]="baseMappingModel.BaseMappingDetails" [isEnabledFilter]="isEnabled"></opm-grid>
          }
        }

        @if (isPagingVisible) {
          <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                      (pageChanged)="onPageChange($event)">
          </opm-paging>
        }
      </div>
    }

    @if (visiblNoMatchesFoundPopup) {
      <opm-modal-popup header="Container Mappings" [cancelVisibility]="false"
                       message="{{noMatchesFoundMsg}}" okButtonName="Ok" (onOk)="gridDataModel = null; visiblNoMatchesFoundPopup = false">
      </opm-modal-popup>
    }
  }

  @if (!isUserAuthorized) {
    <div class="user-unauthorized">{{errorMessage}}</div>
  }
</div>
<opm-footer></opm-footer>

